var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Shield Logistics"),React.createElement("path",{"id":"path1191-9-1-7","className":"cls-1","d":"M99.8,85.27V19.62H33.19V85.27a20.78,20.78,0,0,0,8.91,17.22l24.4,16.56,24.39-16.56A20.78,20.78,0,0,0,99.8,85.27Z","key":2})]);
}

Shield.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Shield;

Shield.default = Shield;
